import { createGetters } from '@/store/extensions/create';
import { updateGetters } from '@/store/extensions/update';

export default {
  ...createGetters,
  ...updateGetters,

  formModalOpened: state => state.formModalOpened,

  currentProfile: (state, getters, rootState, rootGetters) => {
    const currentUser = rootGetters['entities/users/currentUser'];

    return currentUser ? currentUser.profile : null;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/getters.js